import { ProductKey } from "../models";

import { useSearchParameters, useCloudStatus } from ".";

/**
 * useFreeBundlesStatus
 *
 * Hook that determines whether or not to render free bundles UI.
 * Checks for bundles-after-signup feature flag,
 * ensures that bundles-after-signup applies only to
 * single-product signups for JSW or JSM.
 *
 * @returns boolean
 */
export function useFreeBundles(): boolean {
    const { featureFlags } = useCloudStatus();
    const { products } = useSearchParameters();

    return (
        !!featureFlags.enableBundlesAfterSignup &&
        products.length === 1 &&
        products.includes(ProductKey.JIRA_SOFTWARE)
    );
}
